import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useLists } from '../../context/ListsContext';
import useBodyScrollLock from '../../utils/useBodyScrollLock';
import './CreateListModal.css';

const CreateListModal = ({ onClose }) => {
  const { createList } = useLists();
  const [listName, setListName] = useState('');
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState('');

  useBodyScrollLock(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const name = listName.trim();
    
    if (!name) {
      setError('List name cannot be empty');
      return;
    }
    if (name.length > 50) {
      setError('List name must be under 50 characters');
      return;
    }

    setCreating(true);
    setError('');

    try {
      await createList(name);
      onClose();
    } catch (err) {
      console.error('Error creating list:', err);
      setError(err.response?.data?.error || err.message || 'Failed to create list');
    } finally {
      setCreating(false);
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target.className === 'modal-backdrop') {
      onClose();
    }
  };

  const modalContent = (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="create-list-modal">
        <div className="modal-header">
          <h2>Create New List</h2>
          <button className="close-btn" onClick={onClose} aria-label="Close modal">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="list-form">
          <div className="form-group">
            <label htmlFor="listName" className="form-label">Name</label>
            <input
              id="listName"
              type="text"
              className="list-input"
              value={listName}
              onChange={(e) => setListName(e.target.value)}
              placeholder="e.g., Favorite Authors, Crypto News..."
              autoFocus
              maxLength={50}
              disabled={creating}
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="list-actions">
            <button
              type="button"
              className="list-cancel-btn"
              onClick={onClose}
              disabled={creating}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="list-submit-btn"
              disabled={creating || !listName.trim()}
            >
              {creating ? 'Creating...' : 'Create List'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );

  if (typeof document === 'undefined') {
    return modalContent;
  }

  return createPortal(modalContent, document.body);
};

export default CreateListModal;
